module.exports = __webpack_public_path__ + "static/award-2-f281e04e7aa3d307e4dc5a98663eee03.svg";